import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { showToast } from '../../utils/toastManager';
import { track } from '../../utils/analytics';

const FAILED_STATUSES = ['failed', 'cancelled', 'declined'];

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const status = searchParams.get('status');
  const isSuccess = !FAILED_STATUSES.includes(status ?? '');

  useEffect(() => {
    document.title = isSuccess ? 'OfferFlow | Payment Successful' : 'OfferFlow | Payment Failed';

    if (isSuccess) {
      showToast('Payment successful! Your subscription has been activated.', 'success');
      track('purchase', { status });
    } else {
      showToast('Payment was not completed. Please try again.', 'error');
    }

    const timer = setTimeout(() => {
      navigate(isSuccess ? '/welcome' : '/settings/plan/purchase');
    }, 3000);

    return () => clearTimeout(timer);
  }, [isSuccess, navigate, status]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: '16px' }}>
      {isSuccess ? (
        <>
          <h1>Payment Successful!</h1>
          <p>Your subscription has been activated. Redirecting to dashboard...</p>
        </>
      ) : (
        <>
          <h1>Payment Not Completed</h1>
          <p>Redirecting back to plans...</p>
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;
